export type Language = 'en' | 'sl';

export const translations = {
    en: {
        common: {
            loading: 'Loading...',
            save: 'Save',
            cancel: 'Cancel',
            delete: 'Delete',
            edit: 'Edit',
            approve: 'Approve',
            reject: 'Reject',
            today: 'Today',
            yesterday: 'Yesterday',
            tomorrow: 'Tomorrow',
            points: 'Points',
            pts: 'pts',
            done: 'Done!',
            pending: 'Pending',
            approved: 'Approved',
            rejected: 'Rejected',
            back: 'Back',
            sign_out: 'Sign Out',
        },
        nav: {
            dashboard: 'Dashboard',
            quests: 'Quests',
            rewards: 'Rewards',
            family: 'Family',
            home: 'Home',
        },
        kidDetails: {
            activeQuests: 'Active Quests',
            history: 'Quest History',
            noActive: 'No active quests for this kid.',
            noHistory: 'No quest history yet.',
        },
        parentDashboard: {
            title: 'Parent Dashboard',
            questQueue: 'Quest Approval Queue',
            approveAll: 'Approve All',
            noPendingQuests: 'No quests waiting for approval.',
            rewardQueue: 'Reward Redemptions',
            noPendingRewards: 'No rewards waiting for approval.',
            completedBy: 'Completed by',
            wantsToRedeem: 'wants to redeem this',
        },
        parentQuests: {
            title: 'Quests',
            createQuest: 'Create Quest',
            newQuest: 'New Quest',
            editQuest: 'Edit Quest',
            questTitle: 'Quest Title',
            frequency: 'Frequency',
            oneTime: 'One-time',
            daily: 'Daily',
            weekly: 'Weekly',
            assignTo: 'Assign to Kid (Optional)',
            activeQuests: 'Active Quests',
            noActiveQuests: 'No active quests. Create one or check the history!',
            recentActivity: 'Recent Activity',
            createdBy: 'Created by',
            assignToKid: 'Assign to:',
            unassign: 'Click to unassign',
            assign: 'Assign to',
            markCompleted: 'Mark as completed',
        },
        kidHome: {
            hello: 'Hello',
            earlyMorningGreeting: 'Good morning',
            runningGreeting: "Let's Run",
            teethGreeting: 'Rghmmmm',
            nightGreeting: 'Zzzzzz',
            ready: 'Ready for today\'s quests?',
            totalPoints: 'Total Points',
            activeQuests: 'Active Quests',
            noQuests: 'You have no assigned quests right now. Ask your parents!',
            recentlyDone: 'Recently Done',
            pendingApproval: 'Pending Approval',
            streak: 'Streak',
            keepItUp: 'Keep it up!',
        },
        kidRewards: {
            title: 'Rewards Shop',
            availablePoints: 'Available Points',
            history: 'History',
            noRewards: 'No rewards available right now.',
            redeem: 'Redeem',
            redeemNotice: 'Will notify your parents!',
            alreadyPending: 'Waiting for approval',
            myWish: 'My Wish',
            setWish: 'Set Your Next Wish',
            wishPlaceholder: 'What are you working towards?',
            saveWish: 'Save Wish',
            changeWish: 'Change Wish',
            noWishSet: 'No wish set yet',
            workingTowards: 'Working towards:',
        },
        kidRewardHistory: {
            title: 'Reward History',
            noRedemptions: 'No rewards redeemed yet.',
            pending: 'Pending',
            approved: 'Approved',
            rejected: 'Rejected',
            requestedOn: 'Requested on',
            status: 'Status',
        },
        parentRewards: {
            title: 'Rewards',
            history: 'History',
            createReward: 'Create Reward',
            newReward: 'New Reward',
            editReward: 'Edit Reward',
            rewardName: 'Reward Name',
            rewardTitle: 'Reward Title',
            cost: 'Cost (Points)',
            costPoints: 'Cost (Points)',
            saveReward: 'Save Reward',
            active: 'Active',
            noRewards: 'No rewards created yet. Add some prizes to motivate the kids!',
        },
        parentRewardHistory: {
            title: 'Reward History',
            noRedemptions: 'No reward redemptions yet.',
            pending: 'Pending',
            approved: 'Approved',
            rejected: 'Rejected',
            requestedOn: 'Requested on',
            status: 'Status',
            requestedBy: 'Requested by',
            approve: 'Approve',
            reject: 'Reject',
            delete: 'Delete',
            confirmDelete: 'Are you sure you want to delete this redemption request?',
            confirmRevert: 'Are you sure you want to revert this approved reward? Points will be returned.',
        },
        parentFamily: {
            title: 'Family Members',
            addKid: 'Add Kid Profile',
            kidName: 'Kid Display Name',
            joinCode: 'Household Join Code',
            joinCodeNotice: 'Other parents can use this code to join your household.',
            role: 'Role',
            noMembers: 'No members found.',
        },
        login: {
            title: 'NestQ',
            subtitle: 'Build habits, earn rewards, grow together.',
            email: 'Email',
            password: 'Password',
            signIn: 'Sign In',
            signUp: 'Sign Up',
            signingIn: 'Signing in...',
            signingUp: 'Creating account...',
            noAccount: "Don't have an account?",
            haveAccount: 'Already have an account?',
        },
        onboarding: {
            title: 'Setup your Household',
            subtitle: "Let's get you set up",
            householdName: 'Household Name (e.g. The Smiths)',
            parentName: 'Your Name',
            create: 'Create Household',
            createTab: 'Create Household',
            creating: 'Creating...',
            joinTitle: 'Join a Household',
            joinTab: 'Join Household',
            joinCode: 'Join Code',
            join: 'Join',
            joining: 'Joining...',
            welcome: 'Welcome!',
            start: 'Start NestQ',
            askMember: 'Ask a household member to share their ID from the Family page',
            yourRole: 'Your Role',
        },
        landingPage: {
            signIn: 'Sign In',
            getStarted: 'Get Started',
            title: "NestQ isn't another chore app.",
            subtitle: "It's a quiet revolution inside your home.",
            story1: 'Parenting is beautiful. And messy. And loud. And sometimes exhausting.',
            story2: 'NestQ helps turn daily chaos into something lighter.',
            story3: 'Instead of repeating the same reminders, you create small quests. Make the bed. Clear the table. Feed the pet. Kids earn points, see their progress, and feel proud of what they’ve done. You spend less time nagging and more time celebrating.',
            story4: 'Cute little virtual pet Q helps kids stay motivated every step of the way. As they complete tasks, Q grows stronger, happier, and full of energy. When they slow down, Q needs a little help. Responsibility suddenly feels real and fun.',
            story5: 'NestQ isn’t about control. It’s about teamwork.',
            welcome: 'Children build confidence. Parents gain calm. Small tasks become small wins. And small wins build strong habits.',
            emailPlaceholder: "Enter your email",
            beginJourney: "Begin Your Journey",
            redirecting: "Redirecting...",
            noCreditCard: "Start building your nest • No credit card required",
            footerTagline: "Building better nests, one quest at a time.",
            copyright: "© 2026 NestQ. All rights reserved."
        }
    },
    sl: {
        common: {
            loading: 'Nalaganje...',
            save: 'Shrani',
            cancel: 'Prekliči',
            delete: 'Izbriši',
            edit: 'Uredi',
            approve: 'Potrdi',
            reject: 'Zavrni',
            today: 'Danes',
            yesterday: 'Včeraj',
            tomorrow: 'Jutri',
            points: 'Točke',
            pts: 'točk',
            done: 'Opravljeno!',
            pending: 'Čaka',
            approved: 'Potrjeno',
            rejected: 'Zavrnjeno',
            back: 'Nazaj',
            sign_out: 'Odjava',
        },
        nav: {
            dashboard: 'Nadzorna plošča',
            quests: 'Opravila',
            rewards: 'Nagrade',
            family: 'Družina',
            home: 'Domov',
        },
        kidDetails: {
            activeQuests: 'Aktivna opravila',
            history: 'Zgodovina opravil',
            noActive: 'Ni aktivnih opravil za tega otroka.',
            noHistory: 'Zgodovina opravil je še prazna.',
        },
        parentDashboard: {
            title: 'Nadzorna plošča (starš)',
            questQueue: 'Čakalna vrsta opravil',
            approveAll: 'Odobri vse',
            noPendingQuests: 'Ni opravil, ki bi čakala na potrditev.',
            rewardQueue: 'Unovčenje nagrad',
            noPendingRewards: 'Ni nagrad, ki bi čakale na potrditev.',
            completedBy: 'Opravil(a)',
            wantsToRedeem: 'želi unovčiti to nagrado',
        },
        parentQuests: {
            title: 'Opravila',
            createQuest: 'Ustvari opravilo',
            newQuest: 'Novo opravilo',
            editQuest: 'Uredi opravilo',
            questTitle: 'Naslov opravila',
            frequency: 'Pogostost',
            oneTime: 'Enkratno',
            daily: 'Dnevno',
            weekly: 'Tedensko',
            assignTo: 'Dodeli otroku (neobvezno)',
            activeQuests: 'Aktivna opravila',
            noActiveQuests: 'Ni aktivnih opravil. Ustvarite novega ali preverite zgodovino!',
            recentActivity: 'Zadnje aktivnosti',
            createdBy: 'Ustvaril(a)',
            assignToKid: 'Dodeli otroku:',
            unassign: 'Klikni za odstranitev',
            assign: 'Dodeli otroku',
            markCompleted: 'Označi kot opravljeno',
        },
        kidHome: {
            hello: 'Živjo',
            earlyMorningGreeting: 'Dobro jutro',
            runningGreeting: 'Teciva v nov dan',
            teethGreeting: 'Rghmmmm',
            nightGreeting: 'Zzzzzz',
            ready: 'Si pripravljen(a) na današnje naloge?',
            totalPoints: 'Skupaj točk',
            activeQuests: 'Naslednje naloge',
            noQuests: 'Trenutno nimaš dodeljenih opravil. Prosi starše!',
            recentlyDone: 'Zadnja opravila',
            pendingApproval: 'Čaka na potrditev',
            streak: 'Zaporedje',
            keepItUp: 'Nadaljuj tako!',
        },
        kidRewards: {
            title: 'Trgovina z nagradami',
            availablePoints: 'Razpoložljive točke',
            history: 'Zgodovina',
            noRewards: 'Trenutno ni na voljo nobene nagrade.',
            redeem: 'Unovči',
            redeemNotice: 'Starši bodo obveščeni!',
            alreadyPending: 'Čaka na potrditev',
            myWish: 'Moja želja',
            setWish: 'Nastavi svojo naslednjo željo',
            wishPlaceholder: 'Za čim se trudiš?',
            saveWish: 'Shrani željo',
            changeWish: 'Spremeni željo',
            noWishSet: 'Želja še ni nastavljena',
            workingTowards: 'Delam proti:',
        },
        kidRewardHistory: {
            title: 'Zgodovina nagrad',
            noRedemptions: 'Še ni unovčenih nagrad.',
            pending: 'Čaka',
            approved: 'Potrjeno',
            rejected: 'Zavrnjeno',
            requestedOn: 'Zahtevano dne',
            status: 'Status',
        },
        parentRewards: {
            title: 'Nagrade',
            history: 'Zgodovina',
            createReward: 'Ustvari nagrado',
            newReward: 'Nova nagrada',
            editReward: 'Uredi nagrado',
            rewardName: 'Ime nagrade',
            rewardTitle: 'Naslov nagrade',
            cost: 'Cena (točke)',
            costPoints: 'Cena (točke)',
            saveReward: 'Shrani nagrado',
            active: 'Aktivno',
            noRewards: 'Ni še ustvarjenih nagrad. Dodajte kakšno, da motivirate otroke!',
        },
        parentRewardHistory: {
            title: 'Zgodovina nagrad',
            noRedemptions: 'Še ni unovčenih nagrad.',
            pending: 'Čaka',
            approved: 'Potrjeno',
            rejected: 'Zavrnjeno',
            requestedOn: 'Zahtevano dne',
            status: 'Status',
            requestedBy: 'Zahteval',
            approve: 'Odobri',
            reject: 'Zavrni',
            delete: 'Izbriši',
            confirmDelete: 'Ali ste prepričani, da želite izbrisati to zahtevo za unovčenje?',
            confirmRevert: 'Ali ste prepričani, da želite razveljaviti to odobreno nagrado? Točke bodo vrnjene.',
        },
        parentFamily: {
            title: 'Družinski člani',
            addKid: 'Dodaj otrokov profil',
            kidName: 'Otrokovo ime',
            joinCode: 'Koda za pridružitev',
            joinCodeNotice: 'Drugi starši lahko uporabijo to kodo za pridružitev gospodinjstvu.',
            role: 'Vloga',
            noMembers: 'Ni najdenih članov.',
        },
        login: {
            title: 'NestQ',
            subtitle: 'Gradi navade, zasluži nagrade, rasti skupaj.',
            email: 'E-pošta',
            password: 'Geslo',
            signIn: 'Prijava',
            signUp: 'Registracija',
            signingIn: 'Prijavljanje...',
            signingUp: 'Ustvarjanje računa...',
            noAccount: 'Nimate računa?',
            haveAccount: 'Že imate račun?',
        },
        onboarding: {
            title: 'Nastavite svoje gospodinjstvo',
            subtitle: 'Pripravimo vas na uporabo',
            householdName: 'Ime gospodinjstva (npr. Družina Novak)',
            parentName: 'Vaše ime',
            create: 'Ustvari gospodinjstvo',
            createTab: 'Ustvari gospodinjstvo',
            creating: 'Ustvarjanje...',
            joinTitle: 'Pridruži se gospodinjstvu',
            joinTab: 'Pridruži se gospodinjstvu',
            joinCode: 'Koda za pridružitev',
            join: 'Pridruži se',
            joining: 'Pridruževanje...',
            welcome: 'Dobrodošli!',
            start: 'Začni z NestQ',
            askMember: 'Prosite člana gospodinjstva, da deli svojo kodo s strani Družina.',
            yourRole: 'Vaša vloga',
        },
        landingPage: {
            signIn: 'Prijava',
            getStarted: 'Začni',
            title: 'NestQ ni še ena aplikacija za opravila.',
            subtitle: 'To je tiha revolucija znotraj vašega doma.',
            story1: 'Starševstvo je čudovito. In kaotično. In glasno. In včasih izčrpavajoče.',
            story2: 'NestQ pomaga vsakodnevni kaos spremeniti v nekaj lažjega.',
            story3: 'Namesto da vedno znova ponavljate iste stvari, ustvarite majhne naloge. Pospravi posteljo, počisti mizo, vadi klavir, nahrani hišnega ljubljenčka. Otroci zbirajo točke, spremljajo svoj napredek in so ponosni na to, kar so naredili. Vi pa porabite manj časa za priganjanje in več za praznovanje.',
            story4: 'Prisrčen virtualni ljubljenček Q pomaga otrokom ostati motiviraniu. Ko opravijo naloge, Q postane močnejši, srečnejši in poln energije. Če pozabijo na naloge, Q potrebuje malo pomoči. Odgovornost naenkrat postane resnična in zabavna.',
            story5: 'NestQ ni tukaj za nadzor. Gre za sodelovanje, zabavo in grajenje odgovornosti od malih nog.',
            welcome: 'Otroci gradijo samozavest. Starši dobijo več miru. Majhne naloge postanejo majhne zmage. In majhne zmage zgradijo močne navade.',
            emailPlaceholder: 'Vnesite svoj e-poštni naslov',
            beginJourney: 'Začnite svojo potovanje',
            redirecting: 'Preusmerjanje...',
            noCreditCard: 'Začnite graditi svoje gnezdo • Ni potrebna kreditna kartica',
            footerTagline: 'Gradimo boljša gnezda, opravilo za opravilom.',
            copyright: '© 2026 NestQ. Vse pravice pridržane.'
        }
    }
};

export type TranslationKey = keyof typeof translations.en;
